import { render, staticRenderFns } from "./BusinessSolutionPage.vue?vue&type=template&id=70f1f2cd&scoped=true"
import script from "./BusinessSolutionPage.vue?vue&type=script&lang=js"
export * from "./BusinessSolutionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f1f2cd",
  null
  
)

export default component.exports